<template>
  <div>
    <template>
      <v-navigation-drawer
        permanent
        v-model="drawer"
        :mini-variant="mini"
        width="70"
        class="elevation-4"
        style="background-color: #effaea"
      >
        <v-list rounded class="mt-6" dense>
          <v-list-item-group active-class="itemMenuSelected">
            <v-tooltip right v-for="(item, i) in itemsMenu" :key="i">
              <template v-slot:activator="{ on, attrs }">
                <v-list-item
                  v-bind="attrs"
                  v-on="on"
                  class="mb-4"
                  :to="item.to"
                >
                  <v-list-item-icon>
                    <v-icon v-if="item.icon" class="iconMenu" right>
                      {{ item.icon }}
                    </v-icon>
                    <v-icon
                      v-if="
                        item.svg &&
                        item.svg === 'factCheckIcon'
                      "
                      class="iconMenu"
                      right
                    >
                      $factCheckIcon
                    </v-icon>
                    <!--
                  <v-col v-if="mini" class="d-flex mt-n3 ml-n2" style="font-size: 0.5em; position: absolute">
                    <span class='mt-8 ml-n5 black--text' v-text="item.title"/>
                  </v-col>
                -->
                  </v-list-item-icon>
                  <v-list-item-title
                    v-text="item.title"
                    style="font-weight: 700"
                  />
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="item.title"
                      style="font-weight: 700"
                    />
                  </v-list-item-content>
                </v-list-item>
              </template>
              <span>{{ item.title }}</span>
            </v-tooltip>
          </v-list-item-group>
        </v-list>
        <template v-slot:append v-if="!mini">
          <div class="mb-n3 font-weight-bold text-caption text-right">
            v{{ version }}
          </div>
        </template>
      </v-navigation-drawer>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data: () => ({
    drawer: true,
    version: process.env.VUE_APP_VERSION,
  }),
  computed: {
    ...mapState('ModuleMenuLateral', { mini: 'mini', itemsMenu: 'itemsMenu' }),
  },
};
</script>

<style lang="scss">
.iconMenu {
  color: #1e3c0f !important;
  fill: #1e3c0f !important;

  svg {
    position: relative;
    right: 2px;
  }
}

.itemMenuSelected {
  background-color: var(--v-primary-base);
  color: white !important;

  .iconMenu {
    color: #ffffff !important;
    fill: #ffffff !important;
  }
}
</style>
